export const DEMO_IMAGES = {
  hero: "https://images.unsplash.com/photo-1539109136881-3be0616acf4b?auto=format&fit=crop&w=900&q=85",
  tryOn:
    "https://images.unsplash.com/photo-1539008835657-9e8e9680c956?auto=format&fit=crop&w=900&q=85",
  thumbnail:
    "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=280&q=75",
  catalog: [
    "https://images.unsplash.com/photo-1539109136881-3be0616acf4b?auto=format&fit=crop&w=500&q=80",
    "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=500&q=80",
    "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=500&q=80",
    "https://images.unsplash.com/photo-1539008835657-9e8e9680c956?auto=format&fit=crop&w=500&q=80",
    "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=500&q=80",
  ],
};

export const faqs = [
  {
    q: "What makes Reformation genuinely sustainable?",
    a: "Reformation uses the RefScale — a proprietary system that measures the carbon, water, and waste impact of every single product and publishes the results publicly. They use TENCEL™, deadstock fabrics, and recycled fibres, operate from a climate-neutral certified facility, and partner only with certified ethical factories. It's sustainability with receipts.",
  },
  {
    q: "What sizes does Reformation carry?",
    a: "Reformation offers a range of sizes, including US sizes 0–24 and letter sizes from XS to 3X in selected styles. Petite sizing is also available for certain pieces. Size availability varies by product, so check the individual item's size options and measurements before ordering.",
  },
  {
    q: "How does Reformation's fit compare to standard sizing?",
    a: "Reformation generally follows US sizing standards, but fit varies by style, fabric, and silhouette. Some designs are more fitted, while others have a relaxed or oversized cut. Check the product-specific measurements and Reformation's size guide before choosing. For a more comfortable fit in denim, Reformation recommends considering a size up.",
  },
  {
    q: "What's the return policy?",
    a: "Reformation generally accepts returns within 30 days of delivery, provided items are unworn, unwashed, and in their original condition with tags attached. Return shipping fees may apply depending on your country and return method. Items marked Final Sale, along with certain categories such as lingerie and vintage, cannot usually be returned or exchanged.",
  },
  {
    q: "Does Reformation ship internationally?",
    a: "Yes, Reformation offers international shipping to many countries. Shipping availability, delivery costs, and estimated delivery times depend on your destination. You can select your country on Reformation's website to see available options. Applicable taxes, customs duties, and shipping charges are calculated or displayed during checkout.",
  },
];
